import {
  initCollaborator,
  setCollaboratorSettingFilterTitle,
  setCurrentNavPage,
  setSubMenuDirection,
  setSubMenuDirectionToggle
} from "Actions";
import { HORIZONTAL, VERTICAL } from "Config";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import {
  fetchCollaboratorSettingSuggestions,
  fetchNonCategorizedTaskTypeCount,
  fetchSettingCollaborators
} from "Thunks";
import CollaboratorSetting from "./CollaboratorSetting";

class CollaboratorSettingPage extends PureComponent {
  constructor(props) {
    super(props);
    let { uen, name } = this.props.match.params;
    this.state = { organizationUen: uen, name: name };
    this.collaboratorName = name;
  }

  componentDidMount() {
    const { dispatch, subMenuDirection } = this.props;

    dispatch(setCurrentNavPage("BUDGET_PAGE"));

    if (subMenuDirection === VERTICAL) {
      dispatch(setSubMenuDirection(HORIZONTAL));
    }
    dispatch(setSubMenuDirectionToggle(true));

    let { uen } = this.props.match.params;
    this.setState({ organizationUen: uen });
    dispatch(initCollaborator());
    dispatch(fetchNonCategorizedTaskTypeCount());
    dispatch(fetchCollaboratorSettingSuggestions());

    this.props.dispatch(fetchSettingCollaborators());

    if (this.collaboratorName) {
      dispatch(setCollaboratorSettingFilterTitle(this.collaboratorName));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // const { filter } = prevProps;
    // if (filter.label !== this.props.filter.label) {
    //   this.props.dispatch(fetchSettingCollaborators());
    // }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(setSubMenuDirectionToggle(true));
    this.props.dispatch(setCollaboratorSettingFilterTitle(""));
  }

  render() {
    return (
      <div className={`page-content`} style={{ display: "contents" }}>
        <CollaboratorSetting uen={this.state.organizationUen} />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  organization: state.timeSheet.organization,
  filter: state.collaborator.filter,
  subMenuDirection: state.params.subMenuDirection,
  currentOrganization: state.auth.currentOrganization
});

export default connect(mapStateToProps)(CollaboratorSettingPage);



// WEBPACK FOOTER //
// ./src/components/CollaboratorSetting/CollaboratorSettingPage.js